"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrazeProvider = exports.BrazeContext = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _pwaKit = require("../pwa-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrazeContext = exports.BrazeContext = /*#__PURE__*/(0, _react.createContext)({
  initialize: () => {},
  loginCustomer: () => {},
  seUserLanguage: () => {},
  setSubscriptionState: () => {},
  sendLastViewedProductEvent: () => {},
  requestPushPermission: () => {},
  toggleContentCards: () => {},
  showContentCards: () => {},
  hideContentCards: () => {},
  requestContentCardsRefresh: () => {},
  updateUnreadNotificationCount: () => {},
  notificationQuantity: 0,
  unreadNotification: false,
  bannerCards: [],
  termsConditionsCards: new Map(),
  notificationCards: [],
  basketContentCards: []
});
/**
 * Braze Provider
 * May use Braze SDK or SCAPI call, depending on the use case
 *
 * @param sdkKey string
 * @param brazeUrl string
 * @param children React.ReactNode
 */
const BrazeProvider = ({
  children,
  sdkKey,
  brazeUrl
}) => {
  const invalidConfig = !sdkKey || !brazeUrl;
  const api = (0, _pwaKit.useCommerceAPI)();
  const [notificationCards, setNotificationCards] = _react.default.useState([]);
  const [notificationQuantity, setNotificationQuantity] = _react.default.useState(0);
  const [unreadNotification, setUnreadNotification] = _react.default.useState(false);
  const [bannerCards, setBannerCards] = _react.default.useState([]);
  const [termsConditionsCards, setTermsConditionsCards] = _react.default.useState(new Map());
  const [basketContentCards, setBasketContentCards] = _react.default.useState([]);

  /**
   * Initialize Braze SDK
   *
   * @param enableLogging string
   */
  const initialize = enableLogging => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(
      /* webpackExports: [
        'initialize', 
        'openSession', 
        'subscribeToContentCardsUpdates'
      ] */
      '@braze/web-sdk'))).then(({
        initialize,
        openSession,
        subscribeToContentCardsUpdates
      }) => {
        initialize(sdkKey, {
          baseUrl: brazeUrl,
          enableLogging: enableLogging,
          doNotLoadFontAwesome: true,
          serviceWorkerLocation: '/worker.js'
        });
        subscribeToContentCardsUpdates(contentCardSubscriber);
        openSession();
      });
    } catch (error) {}
  };

  /**
   * Content card subscriber
   *
   * @param cards ContentCards
   */
  const contentCardSubscriber = cards => {
    var _cards$cards, _cards$cards2, _cards$cards3, _cards$cards4;
    const notificationCards = cards === null || cards === void 0 ? void 0 : (_cards$cards = cards.cards) === null || _cards$cards === void 0 ? void 0 : _cards$cards.filter(card => {
      var _card$extras;
      return ((_card$extras = card.extras) === null || _card$extras === void 0 ? void 0 : _card$extras.type) === 'notification';
    });
    const bannerCards = cards === null || cards === void 0 ? void 0 : (_cards$cards2 = cards.cards) === null || _cards$cards2 === void 0 ? void 0 : _cards$cards2.filter(card => {
      var _card$extras2, _card$extras3, _card$extras4;
      return (
        // @ts-ignore
        card._ === 'ab-captioned-image' && ((_card$extras2 = card.extras) === null || _card$extras2 === void 0 ? void 0 : _card$extras2.type) === 'banner' && !!((_card$extras3 = card.extras) !== null && _card$extras3 !== void 0 && _card$extras3.anchor_component_id) && !!((_card$extras4 = card.extras) !== null && _card$extras4 !== void 0 && _card$extras4.anchor_position)
      );
    });
    const termsConditionsMap = new Map((_cards$cards3 = cards.cards) === null || _cards$cards3 === void 0 ? void 0 : _cards$cards3.filter(card => {
      var _card$extras5;
      return ((_card$extras5 = card.extras) === null || _card$extras5 === void 0 ? void 0 : _card$extras5.type) === 'terms_conditions';
    }).map(card => {
      var _card$extras6;
      return [(_card$extras6 = card.extras) === null || _card$extras6 === void 0 ? void 0 : _card$extras6.id, card];
    }));
    const basketContentCards = cards === null || cards === void 0 ? void 0 : (_cards$cards4 = cards.cards) === null || _cards$cards4 === void 0 ? void 0 : _cards$cards4.filter(card => {
      var _card$extras7;
      return ((_card$extras7 = card.extras) === null || _card$extras7 === void 0 ? void 0 : _card$extras7.type) === 'cart';
    });
    setTermsConditionsCards(termsConditionsMap);
    setNotificationCards(notificationCards);
    setNotificationQuantity((notificationCards === null || notificationCards === void 0 ? void 0 : notificationCards.length) || 0);
    setBannerCards(bannerCards);
    setBasketContentCards(basketContentCards);
    updateUnreadNotificationCount();
  };

  /**
   * Update unread notification count
   */
  const updateUnreadNotificationCount = () => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['getCachedContentCards'] */
      '@braze/web-sdk'))).then(({
        getCachedContentCards
      }) => {
        var _getCachedContentCard;
        const hasUnreadCards = (_getCachedContentCard = getCachedContentCards().cards) === null || _getCachedContentCard === void 0 ? void 0 : _getCachedContentCard.some(card => {
          var _card$extras8;
          return card.viewed === false && ((_card$extras8 = card.extras) === null || _card$extras8 === void 0 ? void 0 : _card$extras8.type) === 'notification';
        });
        setUnreadNotification(hasUnreadCards);
      });
    } catch (error) {}
  };

  /**
   * Login the customer to Braze
   * If customer is already logged in, it does nothing
   *
   * @param userId string
   */
  const loginCustomer = userId => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['changeUser'] */
      '@braze/web-sdk'))).then(({
        changeUser
      }) => {
        changeUser(userId);
      });
    } catch (error) {}
  };

  /**
   * Set user language in Braze
   *
   * @param language string
   */
  const seUserLanguage = language => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['getUser'] */
      '@braze/web-sdk'))).then(({
        getUser
      }) => {
        const user = getUser();
        if (user) {
          user.setLanguage(language);
        }
      });
    } catch (error) {}
  };

  /**
   * Request push permission from client
   *
   * @returns void
   */
  const requestPushPermission = () => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['requestPushPermission'] */
      '@braze/web-sdk'))).then(({
        requestPushPermission
      }) => {
        requestPushPermission();
      });
    } catch (error) {}
  };

  /**
   * Toggle content cards in Braze
   *
   * @param notificationArea HTMLElement
   * @returns void
   */
  const toggleContentCards = notificationArea => {
    if (invalidConfig || !notificationArea) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['toggleContentCards'] */
      '@braze/web-sdk'))).then(({
        toggleContentCards
      }) => {
        toggleContentCards(notificationArea);
      });
    } catch (error) {}
  };

  /**
   * Update the quantity of category banners
   * in the notification flyout
   *
   * @returns void
   */
  const showContentCards = (notificationArea, filterFunction) => {
    if (invalidConfig || !notificationArea) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['showContentCards'] */
      '@braze/web-sdk'))).then(({
        showContentCards
      }) => {
        showContentCards(notificationArea, filterFunction);
      });
    } catch (error) {}
  };

  /**
   * Update the quantity of category banners
   * in the notification flyout
   *
   * @returns void
   */
  const hideContentCards = () => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['hideContentCards'] */
      '@braze/web-sdk'))).then(({
        hideContentCards
      }) => {
        hideContentCards();
      });
    } catch (error) {}
  };

  /**
   * Create 'last_viewed_product' event in Braze
   *
   * @param productId Product ID
   * @returns void
   */
  const sendLastViewedProductEvent = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (productId) {
      if (invalidConfig) return;
      try {
        Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['logCustomEvent'] */
        '@braze/web-sdk'))).then(({
          logCustomEvent
        }) => {
          logCustomEvent('last_viewed_product', {
            product_id: productId
          });
        });
      } catch (error) {}
    });
    return function sendLastViewedProductEvent(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Set subscription state for a customer
   * Uses the SCAPI custom API instead of Braze SDK
   *
   * @param email string
   * @param subscriptionState string
   */
  const setSubscriptionState = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(function* (email, subscriptionState) {
      const params = {
        parameters: {},
        headers: {}
      };
      const body = {
        c_email: email,
        c_subscription_state: subscriptionState
      };
      try {
        const result = yield api.brazeApi.subscriptionState(params, body);

        // wrong email address does not throw error for security reasons
        if (!result.isError || (result === null || result === void 0 ? void 0 : result.title) === 'CustomerNotFoundError') {
          return {
            success: true
          };
        }
      } catch (e) {}
      return {
        success: false
      };
    });
    return function setSubscriptionState(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Request content cards refresh
   *
   * @returns void
   */
  const requestContentCardsRefresh = () => {
    if (invalidConfig) return;
    try {
      Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackExports: ['requestContentCardsRefresh'] */
      '@braze/web-sdk'))).then(({
        requestContentCardsRefresh
      }) => {
        requestContentCardsRefresh();
      });
    } catch (error) {}
  };
  return /*#__PURE__*/_react.default.createElement(BrazeContext.Provider, {
    value: {
      initialize,
      loginCustomer,
      seUserLanguage,
      setSubscriptionState,
      sendLastViewedProductEvent,
      requestPushPermission,
      toggleContentCards,
      showContentCards,
      hideContentCards,
      requestContentCardsRefresh,
      updateUnreadNotificationCount,
      notificationQuantity,
      unreadNotification,
      bannerCards,
      termsConditionsCards,
      notificationCards,
      basketContentCards
    }
  }, children);
};
exports.BrazeProvider = BrazeProvider;